"use strict";
//
// From Rels.cs
// Defines the Rels class.  This class is used to define the Rels
// used to derive URIs for the WmsRestClient
//
// Generated File - DO NOT EDIT
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rels = void 0;
;
var Rels;
(function (Rels) {
    ;
    let InventorySvc;
    (function (InventorySvc) {
        InventorySvc.ReceiverSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversummaries",
            OnBillboard: true
        };
        InventorySvc.Digests = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverdigests",
            OnBillboard: true
        };
        InventorySvc.DigestsAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverdigestsasync",
            OnBillboard: true
        };
        InventorySvc.DigestBriefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/digestbriefs",
            OnBillboard: true
        };
        InventorySvc.Receivers = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receivers",
            OnBillboard: true
        };
        InventorySvc.ReceiversConfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversconfirm",
            OnBillboard: true
        };
        InventorySvc.ReceiversConfirmAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversconfirmasync",
            OnBillboard: true
        };
        InventorySvc.ReceiversUnconfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversunconfirm",
            OnBillboard: true
        };
        InventorySvc.ReceiversMarkForRa = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversramark",
            OnBillboard: true
        };
        InventorySvc.ReceiversMarkSentRa = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversrasent",
            OnBillboard: true
        };
        InventorySvc.ReceiversCancel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverscancel",
            OnBillboard: true
        };
        InventorySvc.ReceiversAutoCharges = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversautocharges",
            OnBillboard: true
        };
        InventorySvc.Pallets = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/pallets",
            OnBillboard: true
        };
        InventorySvc.ReceiveItems = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiveitems",
            OnBillboard: true
        };
        InventorySvc.Adjustments = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/adjustments",
            OnBillboard: true
        };
        InventorySvc.Adjustment = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/adjustment",
            OnBillboard: true
        };
        InventorySvc.ProposedAllocations = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/proposedallocations",
            OnBillboard: true
        };
        InventorySvc.ProposedReduction = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/proposedreduction",
            OnBillboard: true
        };
        InventorySvc.AdjustmentCharges = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/adjustmentcharges",
            OnBillboard: true
        };
        InventorySvc.Assembly = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assembly",
            OnBillboard: true
        };
        InventorySvc.Assemblies = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblies",
            OnBillboard: true
        };
        InventorySvc.AssembliesCancel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assembliescancel",
            OnBillboard: true
        };
        InventorySvc.AssembliesConfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assembliesconfirm",
            OnBillboard: true
        };
        InventorySvc.AssemblyItem = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyitem",
            OnBillboard: true
        };
        InventorySvc.AssemblyCancel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblycancel",
            OnBillboard: true
        };
        InventorySvc.AssemblyConfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyconfirm",
            OnBillboard: true
        };
        InventorySvc.Items = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/items",
            OnBillboard: true
        };
        InventorySvc.Item = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/item",
            OnBillboard: true
        };
        InventorySvc.Import = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/import",
            OnBillboard: true
        };
        InventorySvc.ImportAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/importasync",
            OnBillboard: true
        };
        InventorySvc.FileExport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/export",
            OnBillboard: true
        };
        InventorySvc.FilesExport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/multiexport",
            OnBillboard: true
        };
        InventorySvc.FileParse = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/fileparse",
            OnBillboard: true
        };
        InventorySvc.FileImport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/fileimport",
            OnBillboard: true
        };
        InventorySvc.FileImportAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/fileimportasync",
            OnBillboard: true
        };
        InventorySvc.AssemblyImport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyimport",
            OnBillboard: true
        };
        InventorySvc.AssemblyImportAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyimportasync",
            OnBillboard: true
        };
        InventorySvc.AssemblyFileParse = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyfileparse",
            OnBillboard: true
        };
        InventorySvc.AssemblyFileImport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyfileimport",
            OnBillboard: true
        };
        InventorySvc.AssemblyFileImportAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyfileimportasync",
            OnBillboard: true
        };
        InventorySvc.PurchaseOrders = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/purchaseorders",
            OnBillboard: true
        };
        InventorySvc.PurchaseOrderIndex = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/purchaseorderindex",
            OnBillboard: true
        };
        InventorySvc.StockDetails = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/stockdetails",
            OnBillboard: true
        };
        InventorySvc.StockInfosForRIs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/stockinfosforris",
            OnBillboard: true
        };
        InventorySvc.StockInfosForWTs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/stockinfosforwts",
            OnBillboard: true
        };
        InventorySvc.StockSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/stocksummaries",
            OnBillboard: true
        };
        InventorySvc.StockSummariesForOrder = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/stocksummariesfororder",
            OnBillboard: true
        };
        InventorySvc.StockSummariesForRIs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/stocksummariesforris",
            OnBillboard: true
        };
        InventorySvc.Inventory = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventory",
            OnBillboard: true
        };
        InventorySvc.InventoryAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryasync",
            OnBillboard: true
        };
        InventorySvc.InventoryExpiring = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryexpiring",
            OnBillboard: true
        };
        InventorySvc.InventoryHold = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryhold",
            OnBillboard: true
        };
        InventorySvc.InventoryHeldReallocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryheldreallocate",
            OnBillboard: true
        };
        InventorySvc.InventoryBriefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventorybriefs",
            OnBillboard: true
        };
        InventorySvc.C2CTransfers = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/c2ctransfers",
            OnBillboard: true
        };
        InventorySvc.Mover = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/mover",
            OnBillboard: true
        };
        InventorySvc.Shaker = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/shaker",
            OnBillboard: true
        };
        InventorySvc.ClusterDeleter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/clusterdeleter",
            OnBillboard: true
        };
        InventorySvc.LocationClearer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/locationclearer",
            OnBillboard: true
        };
        InventorySvc.MassCompleter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/masscompleter",
            OnBillboard: true
        };
        InventorySvc.MoveRequests = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/moverequests",
            OnBillboard: true
        };
        InventorySvc.MoveRequestSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/moverequestsummaries",
            OnBillboard: true
        };
        InventorySvc.MoveRequestGenerator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/moverequestsgenerator",
            OnBillboard: true
        };
        InventorySvc.InventoryItem = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryitem",
            OnBillboard: true
        };
        InventorySvc.InventoryReduction = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryreduction",
            OnBillboard: true
        };
        InventorySvc.AdjustmentReverser = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/adjustmentreverser",
            OnBillboard: false
        };
        InventorySvc.Receiver = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiver",
            OnBillboard: false
        };
        InventorySvc.ReceiverLocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverlocate",
            OnBillboard: false
        };
        InventorySvc.ReceiverComplete = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receivercomplete",
            OnBillboard: false
        };
        InventorySvc.ReceiverCancel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receivercancel",
            OnBillboard: false
        };
        InventorySvc.ReceiverConfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverconfirm",
            OnBillboard: false
        };
        InventorySvc.ReceiverUnconfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverunconfirm",
            OnBillboard: false
        };
        InventorySvc.ReceiverMarkForRa = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverramark",
            OnBillboard: false
        };
        InventorySvc.ReceiverMarkSentRa = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverrasent",
            OnBillboard: false
        };
        InventorySvc.ReceiverAutoCharges = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverautocharges",
            OnBillboard: false
        };
        InventorySvc.ReceiverAsnConvert = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/asnconverter",
            OnBillboard: false
        };
        InventorySvc.SavedElements = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/savedelements",
            OnBillboard: false
        };
        InventorySvc.ReceiverRelocator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/relocator",
            OnBillboard: false
        };
        InventorySvc.ReceiverAsnArrival = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/raasnarrival",
            OnBillboard: false
        };
        InventorySvc.ReceiverStarter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/starter",
            OnBillboard: false
        };
        InventorySvc.ReceiverPauser = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/pauser",
            OnBillboard: false
        };
        InventorySvc.ReceiverResumer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/resumer",
            OnBillboard: false
        };
        InventorySvc.ReceiverFinisher = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/finisher",
            OnBillboard: false
        };
        InventorySvc.ReceiveItemProcessor = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/itemprocessor",
            OnBillboard: false
        };
        InventorySvc.ReceiversConfirmAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiversconfirmasyncstatus",
            OnBillboard: false
        };
        InventorySvc.DigestsAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverdigestsasyncstatus",
            OnBillboard: false
        };
        InventorySvc.DigestsAsyncData = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverdigestsasyncdata",
            OnBillboard: false
        };
        InventorySvc.ReceiverItems = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiveritems",
            OnBillboard: false
        };
        InventorySvc.ReceiverItem = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiveritem",
            OnBillboard: false
        };
        InventorySvc.Pallet = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/pallet",
            OnBillboard: false
        };
        InventorySvc.ReceiverFile = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverfile",
            OnBillboard: false
        };
        InventorySvc.ReceiverFiles = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverfiles",
            OnBillboard: false
        };
        InventorySvc.ReceiverFileSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/receiverfilesummaries",
            OnBillboard: false
        };
        InventorySvc.AssemblyFile = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyfile",
            OnBillboard: false
        };
        InventorySvc.AssemblyFiles = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyfiles",
            OnBillboard: false
        };
        InventorySvc.AssemblyFileSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyfilesummaries",
            OnBillboard: false
        };
        InventorySvc.AdjustmentFile = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/adjustmentfile",
            OnBillboard: false
        };
        InventorySvc.AdjustmentFiles = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/adjustmentfiles",
            OnBillboard: false
        };
        InventorySvc.AdjustmentFileSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/adjustmentfilesummaries",
            OnBillboard: false
        };
        InventorySvc.ImportAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/importasyncstatus",
            OnBillboard: false
        };
        InventorySvc.FileImportAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/fileimportasyncstatus",
            OnBillboard: false
        };
        InventorySvc.AssemblyImportAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyimportasyncstatus",
            OnBillboard: false
        };
        InventorySvc.AssemblyFileImportAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/assemblyfileimportasyncstatus",
            OnBillboard: false
        };
        InventorySvc.PurchaseOrder = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/purchaseorder",
            OnBillboard: false
        };
        InventorySvc.InventoryAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryasyncstatus",
            OnBillboard: false
        };
        InventorySvc.InventoryAsyncData = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/inventoryasyncdata",
            OnBillboard: false
        };
        InventorySvc.Locations = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/locations",
            OnBillboard: false
        };
        InventorySvc.ItemMinimumReached = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/itemminimum",
            OnBillboard: false
        };
        InventorySvc.LocationMinimumReached = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/locationminimum",
            OnBillboard: false
        };
        InventorySvc.Audit = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/audit",
            OnBillboard: false
        };
        InventorySvc.Audits = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/audits",
            OnBillboard: false
        };
        InventorySvc.AuditCount = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/auditcount",
            OnBillboard: false
        };
        InventorySvc.AuditCounts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/auditcounts",
            OnBillboard: false
        };
        InventorySvc.AuditLocationCounts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/auditlocationcounts",
            OnBillboard: false
        };
        InventorySvc.AuditStateChange = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/auditstatechange",
            OnBillboard: false
        };
        InventorySvc.AuditSwap = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/auditswap",
            OnBillboard: false
        };
        InventorySvc.AuditAdjust = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/auditadjust",
            OnBillboard: false
        };
        InventorySvc.AuditLocationEmpty = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/empty",
            OnBillboard: false
        };
        InventorySvc.MoveRequest = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/moverequest",
            OnBillboard: false
        };
        InventorySvc.MoveRequestGeneratorResponse = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/moverequestsgeneratorresponse",
            OnBillboard: false
        };
        InventorySvc.MoveRequestSummary = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/moverequestsummary",
            OnBillboard: false
        };
        InventorySvc.MoveRequestsForLocation = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/moverequestsforlocation",
            OnBillboard: false
        };
        InventorySvc.MoveRequestSelect = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/select",
            OnBillboard: false
        };
        InventorySvc.MoveRequestDeselect = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/deselect",
            OnBillboard: false
        };
        InventorySvc.Allocation = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/inventory",
            Rel: "http://api.3plCentral.com/rels/inventory/allocation",
            OnBillboard: false
        };
    })(InventorySvc = Rels.InventorySvc || (Rels.InventorySvc = {}));
    ;
    let OrderSvc;
    (function (OrderSvc) {
        OrderSvc.Batches = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batches",
            OnBillboard: true
        };
        OrderSvc.BatchSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batchsummaries",
            OnBillboard: true
        };
        OrderSvc.BatchSummaryIndex = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batchsummaryindex",
            OnBillboard: true
        };
        OrderSvc.AddToBatchBucket = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/bucketadder",
            OnBillboard: true
        };
        OrderSvc.ProcessBuckets = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/bucketprocessor",
            OnBillboard: true
        };
        OrderSvc.Import = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/import",
            OnBillboard: true
        };
        OrderSvc.ImportAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/importasync",
            OnBillboard: true
        };
        OrderSvc.FileExport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/export",
            OnBillboard: true
        };
        OrderSvc.FilesExport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/multiexport",
            OnBillboard: true
        };
        OrderSvc.FileParse = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/fileparse",
            OnBillboard: true
        };
        OrderSvc.FileImport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/fileimport",
            OnBillboard: true
        };
        OrderSvc.FileImportAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/fileimportasync",
            OnBillboard: true
        };
        OrderSvc.Summaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/summaries",
            OnBillboard: true
        };
        OrderSvc.Digests = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/digests",
            OnBillboard: true
        };
        OrderSvc.DigestBriefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/digestbriefs",
            OnBillboard: true
        };
        OrderSvc.Order = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/order",
            OnBillboard: true
        };
        OrderSvc.Orders = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orders",
            OnBillboard: true
        };
        OrderSvc.OrdersAllocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersallocate",
            OnBillboard: true
        };
        OrderSvc.OrdersDeallocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersdeallocate",
            OnBillboard: true
        };
        OrderSvc.OrdersConfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersconfirm",
            OnBillboard: true
        };
        OrderSvc.OrdersConfirmAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersconfirmasync",
            OnBillboard: true
        };
        OrderSvc.OrdersConfirmAftermath = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersconfirmaftermath",
            OnBillboard: true
        };
        OrderSvc.OrdersComplete = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderscomplete",
            OnBillboard: true
        };
        OrderSvc.OrdersCancel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderscancel",
            OnBillboard: true
        };
        OrderSvc.OrdersUnconfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersunconfirm",
            OnBillboard: true
        };
        OrderSvc.OrdersSplit = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderssplit",
            OnBillboard: true
        };
        OrderSvc.OrdersShort = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersshort",
            OnBillboard: true
        };
        OrderSvc.OrdersRouting = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersrouting",
            OnBillboard: true
        };
        OrderSvc.OrdersAutoCharges = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersautocharges",
            OnBillboard: true
        };
        OrderSvc.OrdersAsnPreCheck = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersasnprecheck",
            OnBillboard: true
        };
        OrderSvc.OrdersMarkForAsn = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersasnmark",
            OnBillboard: true
        };
        OrderSvc.OrdersMarkSentAsn = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersasnsent",
            OnBillboard: true
        };
        OrderSvc.OrdersSetPickTicketDate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderspickticketdatesetter",
            OnBillboard: true
        };
        OrderSvc.MasterBolGenerate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/masterbolgenerate",
            OnBillboard: true
        };
        OrderSvc.MasterBolClear = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/masterbolclear",
            OnBillboard: true
        };
        OrderSvc.BolsGenerate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/bolsgenerate",
            OnBillboard: true
        };
        OrderSvc.ItemsOverallocated = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/itemsoverallocated",
            OnBillboard: true
        };
        OrderSvc.PickCandidates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickcandidates",
            OnBillboard: true
        };
        OrderSvc.PickJobs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickjobs",
            OnBillboard: true
        };
        OrderSvc.OrdersbyBin = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersbybin",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelCanceler = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelcanceler",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelFinalizer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelfinalizer",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelFinalizerHvp = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelfinalizerhvp",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelShippingLabel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelshippinglabel",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelShippingLabelHighVolume = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelshippinglabelhighvolume",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelShippingLabelsHighVolume = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelshippinglabelshighvolume",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelOptions = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparceloptions",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelBatch = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelbatch",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelBatches = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelbatches",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelBatchLabels = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelbatchlabels",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelBatchErrors = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelbatcherrors",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelReturnLabel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelreturnlabel",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelAutoRateShop = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelautorateshop",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelAutoRateShopOnShip = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelautorateshoponship",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelAutoRateShopBatch = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelautorateshopbatch",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelTmwExporter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparceltmwexporter",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelShippingLabelsDatabase = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelshippinglabelsdatabase",
            OnBillboard: true
        };
        OrderSvc.OrdersParcelManifestsDatabase = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersparcelmanifestsdatabase",
            OnBillboard: true
        };
        OrderSvc.ContainerManifest = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/containermanifest",
            OnBillboard: true
        };
        OrderSvc.ContainerManifests = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/containermanifests",
            OnBillboard: true
        };
        OrderSvc.PackagesGenerates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesgenerates",
            OnBillboard: true
        };
        OrderSvc.PackagesConsolidates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesconsolidates",
            OnBillboard: true
        };
        OrderSvc.PackagesConsolidatesByCustomDims = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesconsolidatesbycustomdims",
            OnBillboard: true
        };
        OrderSvc.PackageHaveNots = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagehavenots",
            OnBillboard: true
        };
        OrderSvc.PackagesUcc128Label = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesucc128label",
            OnBillboard: true
        };
        OrderSvc.PackagesLabelTemplates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packageslabeltemplates",
            OnBillboard: true
        };
        OrderSvc.PackagesRestockAlert = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesrestockalert",
            OnBillboard: true
        };
        OrderSvc.PackagesRestockAlerts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesrestockalerts",
            OnBillboard: true
        };
        OrderSvc.Batch = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batch",
            OnBillboard: false
        };
        OrderSvc.BatchSummary = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batchsummary",
            OnBillboard: false
        };
        OrderSvc.FulfillInv = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/fulfillinv",
            OnBillboard: false
        };
        OrderSvc.OrderRouting = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderrouting",
            OnBillboard: false
        };
        OrderSvc.SavedElements = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/savedelements",
            OnBillboard: false
        };
        OrderSvc.OrderAllocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderallocate",
            OnBillboard: false
        };
        OrderSvc.OrderDeallocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderdeallocate",
            OnBillboard: false
        };
        OrderSvc.OrderSplit = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersplit",
            OnBillboard: false
        };
        OrderSvc.OrderShort = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordershort",
            OnBillboard: false
        };
        OrderSvc.OrderConfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderconfirm",
            OnBillboard: false
        };
        OrderSvc.OrderUnconfirm = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderunconfirm",
            OnBillboard: false
        };
        OrderSvc.OrderComplete = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordercomplete",
            OnBillboard: false
        };
        OrderSvc.OrderCancel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordercancel",
            OnBillboard: false
        };
        OrderSvc.OrderAutoCharges = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderautocharges",
            OnBillboard: false
        };
        OrderSvc.OrderMarkForAsn = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderasnmark",
            OnBillboard: false
        };
        OrderSvc.OrderSetPickTicketDate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderpickticketdatesetter",
            OnBillboard: false
        };
        OrderSvc.OrderSetPackDate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderpackdatesetter",
            OnBillboard: false
        };
        OrderSvc.OrderStartPack = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderpackstarter",
            OnBillboard: false
        };
        OrderSvc.OrderMarkSentAsn = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderasnsent",
            OnBillboard: false
        };
        OrderSvc.OrderTransfer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordertransfer",
            OnBillboard: false
        };
        OrderSvc.OrderPackEvent = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderpackevent",
            OnBillboard: false
        };
        OrderSvc.OrdersConfirmAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/ordersconfirmasyncstatus",
            OnBillboard: false
        };
        OrderSvc.PackingListAddressesGenerate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packinglistaddresser",
            OnBillboard: false
        };
        OrderSvc.BolGenerate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/bolgenerate",
            OnBillboard: false
        };
        OrderSvc.Items = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/items",
            OnBillboard: false
        };
        OrderSvc.Item = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/item",
            OnBillboard: false
        };
        OrderSvc.OrderItemAllocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/itemallocate",
            OnBillboard: false
        };
        OrderSvc.OrderItemDeallocate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/itemdeallocate",
            OnBillboard: false
        };
        OrderSvc.ImportAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/importasyncstatus",
            OnBillboard: false
        };
        OrderSvc.FileImportAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/fileimportasyncstatus",
            OnBillboard: false
        };
        OrderSvc.BatchFile = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batchfile",
            OnBillboard: false
        };
        OrderSvc.BatchFiles = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batchfiles",
            OnBillboard: false
        };
        OrderSvc.BatchFileSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/batchfilesummaries",
            OnBillboard: false
        };
        OrderSvc.OrderFile = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderfile",
            OnBillboard: false
        };
        OrderSvc.OrderFiles = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderfiles",
            OnBillboard: false
        };
        OrderSvc.OrderFileSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderfilesummaries",
            OnBillboard: false
        };
        OrderSvc.Packages = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packages",
            OnBillboard: false
        };
        OrderSvc.Package = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/package",
            OnBillboard: false
        };
        OrderSvc.PackageContents = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagecontents",
            OnBillboard: false
        };
        OrderSvc.PackageContent = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagecontent",
            OnBillboard: false
        };
        OrderSvc.PackagesGenerate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesgenerate",
            OnBillboard: false
        };
        OrderSvc.PackagesConsolidate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesconsolidate",
            OnBillboard: false
        };
        OrderSvc.PackagesConsolidateByCustomDims = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagesconsolidatebycustomdims",
            OnBillboard: false
        };
        OrderSvc.PackagesSummarize = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packagessummarize",
            OnBillboard: false
        };
        OrderSvc.PackageUcc128Label = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/packageucc128label",
            OnBillboard: false
        };
        OrderSvc.PickJob = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickjob",
            OnBillboard: false
        };
        OrderSvc.StartPick = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/startpick",
            OnBillboard: false
        };
        OrderSvc.PickJobPause = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickjobpause",
            OnBillboard: false
        };
        OrderSvc.PickJobComplete = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickjobcomplete",
            OnBillboard: false
        };
        OrderSvc.PickJobLoad = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickjobload",
            OnBillboard: false
        };
        OrderSvc.PickList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/picklist",
            OnBillboard: false
        };
        OrderSvc.Pick = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pick",
            OnBillboard: false
        };
        OrderSvc.Unpick = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/unpick",
            OnBillboard: false
        };
        OrderSvc.Mispick = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/mispick",
            OnBillboard: false
        };
        OrderSvc.Load = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/load",
            OnBillboard: false
        };
        OrderSvc.PickItemAssign = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickitemassign",
            OnBillboard: false
        };
        OrderSvc.PickItem = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/pickitem",
            OnBillboard: false
        };
        OrderSvc.OrderParcelCanceler = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderparcelcanceler",
            OnBillboard: false
        };
        OrderSvc.OrderParcelFinalizer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderparcelfinalizer",
            OnBillboard: false
        };
        OrderSvc.OrderParcelShippingLabel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderparcelshippinglabel",
            OnBillboard: false
        };
        OrderSvc.OrderParcelReturnLabel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderparcelreturnlabel",
            OnBillboard: false
        };
        OrderSvc.OrderParcelLabelRefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderparcellabelrefs",
            OnBillboard: false
        };
        OrderSvc.ShipEngineBatchCompletedWebHook = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/shipenginebatchcompletedwebhook",
            OnBillboard: false
        };
        OrderSvc.ParcelApiBatchCompletedWebHook = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/parcelapibatchcompletedwebhook",
            OnBillboard: false
        };
        OrderSvc.OrderParcelTmwExporter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/orders",
            Rel: "http://api.3plCentral.com/rels/orders/orderparceltmwexporter",
            OnBillboard: false
        };
    })(OrderSvc = Rels.OrderSvc || (Rels.OrderSvc = {}));
    ;
    let CustomerSvc;
    (function (CustomerSvc) {
        CustomerSvc.Summaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customersummaries",
            OnBillboard: true
        };
        CustomerSvc.CustomerList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customers",
            OnBillboard: true
        };
        CustomerSvc.CustomerBriefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerbriefs",
            OnBillboard: true
        };
        CustomerSvc.CustomersActivate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customersactivate",
            OnBillboard: true
        };
        CustomerSvc.ErrorLogs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/errorlogs",
            OnBillboard: true
        };
        CustomerSvc.CustomerOrderSource = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerordersource",
            OnBillboard: true
        };
        CustomerSvc.CustomerOrderSources = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerordersources",
            OnBillboard: true
        };
        CustomerSvc.Suppliers = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/suppliers",
            OnBillboard: true
        };
        CustomerSvc.Alerts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/alerts",
            OnBillboard: true
        };
        CustomerSvc.AlertContents = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/alertcontents",
            OnBillboard: true
        };
        CustomerSvc.EventAlerter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/eventalerter",
            OnBillboard: true
        };
        CustomerSvc.AlertHistory = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/alerthistory",
            OnBillboard: true
        };
        CustomerSvc.Items = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/items",
            OnBillboard: true
        };
        CustomerSvc.ItemBriefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itembriefs",
            OnBillboard: true
        };
        CustomerSvc.ItemsAsync = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemsasync",
            OnBillboard: true
        };
        CustomerSvc.ItemSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemsummaries",
            OnBillboard: true
        };
        CustomerSvc.ItemSummariesAcrossCustomers = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemsummariesacrosscustomers",
            OnBillboard: true
        };
        CustomerSvc.ItemsActivate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemsactivate",
            OnBillboard: true
        };
        CustomerSvc.ItemExchangeList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemexchanges",
            OnBillboard: true
        };
        CustomerSvc.ItemImportList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemimports",
            OnBillboard: true
        };
        CustomerSvc.ItemCreateList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemscreate",
            OnBillboard: true
        };
        CustomerSvc.ItemIndex = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemindex",
            OnBillboard: true
        };
        CustomerSvc.ItemAssemblyIndex = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemassemblyindex",
            OnBillboard: true
        };
        CustomerSvc.Channels = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/channels",
            OnBillboard: true
        };
        CustomerSvc.ItemizedChargesList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemizedchargeslist",
            OnBillboard: true
        };
        CustomerSvc.InvoiceBinder = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/invoicebinder",
            OnBillboard: true
        };
        CustomerSvc.ChargesList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/chargeslist",
            OnBillboard: true
        };
        CustomerSvc.Charges = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/charges",
            OnBillboard: true
        };
        CustomerSvc.ChargesReverser = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/chargesreverser",
            OnBillboard: false
        };
        CustomerSvc.Summary = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customersummary",
            OnBillboard: false
        };
        CustomerSvc.Customer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customer",
            OnBillboard: false
        };
        CustomerSvc.CustomerAutoRates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerautorates",
            OnBillboard: false
        };
        CustomerSvc.CustomerManualRates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customermanualrates",
            OnBillboard: false
        };
        CustomerSvc.CustomerTransform = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customertransform",
            OnBillboard: false
        };
        CustomerSvc.CustomerTransforms = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customertransforms",
            OnBillboard: false
        };
        CustomerSvc.CustomerBarcodeDefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerbarcodedefs",
            OnBillboard: false
        };
        CustomerSvc.CustomerBarcodeDef = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerbarcodedef",
            OnBillboard: false
        };
        CustomerSvc.CustomerLogo = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerlogo",
            OnBillboard: false
        };
        CustomerSvc.PackingListTemplates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/packinglisttemplates",
            OnBillboard: false
        };
        CustomerSvc.PackingListTemplate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/packinglisttemplate",
            OnBillboard: false
        };
        CustomerSvc.CustomerFtpSites = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerftpsites",
            OnBillboard: false
        };
        CustomerSvc.CustomerBolTemplates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerboltemplates",
            OnBillboard: false
        };
        CustomerSvc.CustomerBolTemplate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerboltemplate",
            OnBillboard: false
        };
        CustomerSvc.CustomerBolMessages = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerbolmessages",
            OnBillboard: false
        };
        CustomerSvc.CustomerBolMessage = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customerbolmessage",
            OnBillboard: false
        };
        CustomerSvc.CustomerCarrierAccount = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customercarrieraccount",
            OnBillboard: false
        };
        CustomerSvc.CustomerCarrierAccounts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/customercarrieraccounts",
            OnBillboard: false
        };
        CustomerSvc.MarkForList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/markforlist",
            OnBillboard: false
        };
        CustomerSvc.MarkForLists = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/markforlists",
            OnBillboard: false
        };
        CustomerSvc.CustomerCarrierMarkup = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/carriermarkup",
            OnBillboard: false
        };
        CustomerSvc.CustomerCarrierMarkups = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/carriermarkups",
            OnBillboard: false
        };
        CustomerSvc.OrderContacts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/ordercontacts",
            OnBillboard: false
        };
        CustomerSvc.OrderContact = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/ordercontact",
            OnBillboard: false
        };
        CustomerSvc.SupplierIndex = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/supplierindex",
            OnBillboard: false
        };
        CustomerSvc.Supplier = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/supplier",
            OnBillboard: false
        };
        CustomerSvc.Retailers = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/retailers",
            OnBillboard: false
        };
        CustomerSvc.Retailer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/retailer",
            OnBillboard: false
        };
        CustomerSvc.Alert = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/alert",
            OnBillboard: false
        };
        CustomerSvc.AlertQueuer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/alertqueuer",
            OnBillboard: false
        };
        CustomerSvc.AlertContent = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/alertcontent",
            OnBillboard: false
        };
        CustomerSvc.AlertFailer = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/alertfailer",
            OnBillboard: false
        };
        CustomerSvc.EmailTemplate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/emailtemplate",
            OnBillboard: false
        };
        CustomerSvc.EmailAlertDef = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/emailalertdef",
            OnBillboard: false
        };
        CustomerSvc.EmailAlertDefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/emailalertdefs",
            OnBillboard: false
        };
        CustomerSvc.FtpAlertDef = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/ftpalertdef",
            OnBillboard: false
        };
        CustomerSvc.FtpAlertDefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/ftpalertdefs",
            OnBillboard: false
        };
        CustomerSvc.Item = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/item",
            OnBillboard: false
        };
        CustomerSvc.ItemSummary = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemsummary",
            OnBillboard: false
        };
        CustomerSvc.ItemAliasList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemaliases",
            OnBillboard: false
        };
        CustomerSvc.ItemAlias = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemalias",
            OnBillboard: false
        };
        CustomerSvc.SkusUnionAliases = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/skusunionaliases",
            OnBillboard: false
        };
        CustomerSvc.ItemImport = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemimport",
            OnBillboard: false
        };
        CustomerSvc.ItemRates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemrates",
            OnBillboard: false
        };
        CustomerSvc.ItemRatesGroup = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemratesgroup",
            OnBillboard: false
        };
        CustomerSvc.ItemRatesGroups = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemratesgroups",
            OnBillboard: false
        };
        CustomerSvc.ItemImage = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemimage",
            OnBillboard: false
        };
        CustomerSvc.ItemActivate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemactivate",
            OnBillboard: false
        };
        CustomerSvc.ItemsAsyncStatus = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemsasyncstatus",
            OnBillboard: false
        };
        CustomerSvc.ItemsAsyncData = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/itemsasyncdata",
            OnBillboard: false
        };
        CustomerSvc.Channel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/customers",
            Rel: "http://api.3plCentral.com/rels/customers/channel",
            OnBillboard: false
        };
    })(CustomerSvc = Rels.CustomerSvc || (Rels.CustomerSvc = {}));
    ;
    let PropertySvc;
    (function (PropertySvc) {
        PropertySvc.FacilityList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/facilities",
            OnBillboard: true
        };
        PropertySvc.FacilitySummaryList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/facilitysummaries",
            OnBillboard: true
        };
        PropertySvc.FacilitiesActivate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/facilitiesactivate",
            OnBillboard: true
        };
        PropertySvc.LocationList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locations",
            OnBillboard: true
        };
        PropertySvc.LocationListByFac = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locationsbyfac",
            OnBillboard: true
        };
        PropertySvc.LocationListByFacBriefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locationsbyfacbriefs",
            OnBillboard: true
        };
        PropertySvc.LocationsActivate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locationsactivate",
            OnBillboard: true
        };
        PropertySvc.LocationsActivateByFac = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locationsactivatebyfac",
            OnBillboard: true
        };
        PropertySvc.LocationBillingTypeList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locationbillingtypes",
            OnBillboard: true
        };
        PropertySvc.LocationIndex = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locationindex",
            OnBillboard: true
        };
        PropertySvc.RecentStockLocations = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/recentstocklocations",
            OnBillboard: true
        };
        PropertySvc.ItemClassificationList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/itemclassifications",
            OnBillboard: true
        };
        PropertySvc.ItemCommodityList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/itemcommodities",
            OnBillboard: true
        };
        PropertySvc.StorageCountScriptList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/storagecountscripts",
            OnBillboard: true
        };
        PropertySvc.UnitOfMeasureList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/unitofmeasuretypes",
            OnBillboard: true
        };
        PropertySvc.CarrierList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carriers",
            OnBillboard: true
        };
        PropertySvc.CapacityTypeList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/capacitytypes",
            OnBillboard: true
        };
        PropertySvc.PalletTypeList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/pallettypes",
            OnBillboard: true
        };
        PropertySvc.PackageDef = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packagedef",
            OnBillboard: true
        };
        PropertySvc.PackageDefList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packagedefs",
            OnBillboard: true
        };
        PropertySvc.PackageDefFacility = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packagedeffacility",
            OnBillboard: true
        };
        PropertySvc.PackageDefFacilitiesList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packagedeffacilities",
            OnBillboard: true
        };
        PropertySvc.ZplLabelList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/zpllabels",
            OnBillboard: true
        };
        PropertySvc.PackageInsert = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packageinsert",
            OnBillboard: true
        };
        PropertySvc.PackageInsertList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packageinserts",
            OnBillboard: true
        };
        PropertySvc.PackageInsertFacility = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packageinsertfacility",
            OnBillboard: true
        };
        PropertySvc.PackageInsertFacilitiesList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packageinsertsfacilities",
            OnBillboard: true
        };
        PropertySvc.EnumList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/enums",
            OnBillboard: true
        };
        PropertySvc.Enum = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/enum",
            OnBillboard: true
        };
        PropertySvc.Countries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/countries",
            OnBillboard: true
        };
        PropertySvc.QueryParameterValues = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/queryparametervalues",
            OnBillboard: true
        };
        PropertySvc.Transforms = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/transforms",
            OnBillboard: true
        };
        PropertySvc.TransformCustoms = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/transformcustoms",
            OnBillboard: true
        };
        PropertySvc.ApiCredentials = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/apicredentials",
            OnBillboard: true
        };
        PropertySvc.CellCarrierList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/cellcarriers",
            OnBillboard: true
        };
        PropertySvc.FlushCache = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/flushcache",
            OnBillboard: true
        };
        PropertySvc.ImportProviderList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/importproviders",
            OnBillboard: true
        };
        PropertySvc.EmailTemplateFields = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/emailtemplatefields",
            OnBillboard: true
        };
        PropertySvc.EmailTemplate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/emailtemplate",
            OnBillboard: true
        };
        PropertySvc.PackingListTemplateList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packinglisttemplates",
            OnBillboard: true
        };
        PropertySvc.PackingListTemplate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/packinglisttemplate",
            OnBillboard: true
        };
        PropertySvc.CarrierAccountRegistrar = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrieraccountregistrar",
            OnBillboard: true
        };
        PropertySvc.CarrierAccountManifestList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrieraccountsmanifests",
            OnBillboard: true
        };
        PropertySvc.CarrierAccountManifestsList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrieraccountsmanifestlist",
            OnBillboard: true
        };
        PropertySvc.CarrierAccountContainerManifestList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrieraccountscontainermanifests",
            OnBillboard: true
        };
        PropertySvc.CarrierAccount = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrieraccount",
            OnBillboard: true
        };
        PropertySvc.XactionBillingScriptTemplates = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/xactionbillingscripttemplates",
            OnBillboard: true
        };
        PropertySvc.Contacts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/contacts",
            OnBillboard: true
        };
        PropertySvc.CarrierAccountMapping = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrieraccountsmapping",
            OnBillboard: true
        };
        PropertySvc.CarrierAccountMappings = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrieraccountsmappings",
            OnBillboard: true
        };
        PropertySvc.ThreePl = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/threepl",
            OnBillboard: true
        };
        PropertySvc.ThreePlSummary = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/threeplsummary",
            OnBillboard: true
        };
        PropertySvc.ThreePlSummaryByGuid = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/threeplsummarybyguid",
            OnBillboard: true
        };
        PropertySvc.Facility = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/facility",
            OnBillboard: false
        };
        PropertySvc.FacilitySummary = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/facilitysummary",
            OnBillboard: false
        };
        PropertySvc.Location = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/location",
            OnBillboard: false
        };
        PropertySvc.LocationBillingType = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/locationbillingtype",
            OnBillboard: false
        };
        PropertySvc.FacilityCarrierAccount = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/facilitycarrieraccount",
            OnBillboard: false
        };
        PropertySvc.FacilityCarrierAccounts = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/facilitycarrieraccounts",
            OnBillboard: false
        };
        PropertySvc.ItemClassification = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/itemclassification",
            OnBillboard: false
        };
        PropertySvc.ItemCommodity = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/itemcommodity",
            OnBillboard: false
        };
        PropertySvc.UnitOfMeasure = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/unitofmeasuretype",
            OnBillboard: false
        };
        PropertySvc.Carrier = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/carrier",
            OnBillboard: false
        };
        PropertySvc.CapacityType = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/capacitytype",
            OnBillboard: false
        };
        PropertySvc.PalletType = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/pallettype",
            OnBillboard: false
        };
        PropertySvc.ZplLabel = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/zpllabel",
            OnBillboard: false
        };
        PropertySvc.QueryParameterValue = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/queryparametervalue",
            OnBillboard: false
        };
        PropertySvc.ApiCredential = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/apicredential",
            OnBillboard: false
        };
        PropertySvc.CellCarrier = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/cellcarrier",
            OnBillboard: false
        };
        PropertySvc.TransformCustom = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/transformcustom",
            OnBillboard: false
        };
        PropertySvc.XactionBillingScriptTemplate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/xactionbillingscripttemplate",
            OnBillboard: false
        };
        PropertySvc.Contact = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/properties",
            Rel: "http://api.3plCentral.com/rels/properties/contact",
            OnBillboard: false
        };
    })(PropertySvc = Rels.PropertySvc || (Rels.PropertySvc = {}));
    ;
    let UiPropertySvc;
    (function (UiPropertySvc) {
        UiPropertySvc.CustomRoleSummaryList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/customrolesummaries",
            OnBillboard: true
        };
        UiPropertySvc.CustomRoleList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/customroles",
            OnBillboard: true
        };
        UiPropertySvc.SystemRoleSummaryList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/systemrolesummaries",
            OnBillboard: true
        };
        UiPropertySvc.Rights = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/rights",
            OnBillboard: true
        };
        UiPropertySvc.Policies = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/policies",
            OnBillboard: true
        };
        UiPropertySvc.ClientMetaData = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/clientmetadata",
            OnBillboard: true
        };
        UiPropertySvc.ClientMetaDataList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/clientmetadatas",
            OnBillboard: true
        };
        UiPropertySvc.User = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/user",
            OnBillboard: true
        };
        UiPropertySvc.UserList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/users",
            OnBillboard: true
        };
        UiPropertySvc.UserIndex = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/userindex",
            OnBillboard: true
        };
        UiPropertySvc.UsersActivate = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/usersactivate",
            OnBillboard: true
        };
        UiPropertySvc.UsersAssignRole = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/usersassignrole",
            OnBillboard: true
        };
        UiPropertySvc.MobileUserAvailable = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/mobileuseravailable",
            OnBillboard: true
        };
        UiPropertySvc.TextOverrideList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/textoverrides",
            OnBillboard: true
        };
        UiPropertySvc.ThreePlLogo = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/threepllogo",
            OnBillboard: true
        };
        UiPropertySvc.SystemRole = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/systemrole",
            OnBillboard: false
        };
        UiPropertySvc.CustomRole = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/customrole",
            OnBillboard: false
        };
        UiPropertySvc.TextOverride = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/uiproperties",
            Rel: "http://api.3plCentral.com/rels/uiproperties/textoverride",
            OnBillboard: false
        };
    })(UiPropertySvc = Rels.UiPropertySvc || (Rels.UiPropertySvc = {}));
    ;
    let ReportDefsSvc;
    (function (ReportDefsSvc) {
        ReportDefsSvc.SsrsSummary = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrssummary",
            OnBillboard: true
        };
        ReportDefsSvc.SsrsNames = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrsnames",
            OnBillboard: true
        };
        ReportDefsSvc.SsrsDefs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrsdefs",
            OnBillboard: true
        };
        ReportDefsSvc.SsrsRun = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrsrun",
            OnBillboard: false
        };
        ReportDefsSvc.SsrsRunC11n = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrsrunc11n",
            OnBillboard: false
        };
        ReportDefsSvc.SsrsDef = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrsdef",
            OnBillboard: false
        };
        ReportDefsSvc.SsrsDefC11n = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrsdefc11n",
            OnBillboard: false
        };
        ReportDefsSvc.SsrsDefC11ns = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/reportdefs",
            Rel: "http://api.3plCentral.com/rels/reportdefs/ssrsdefc11ns",
            OnBillboard: false
        };
    })(ReportDefsSvc = Rels.ReportDefsSvc || (Rels.ReportDefsSvc = {}));
    ;
    let MasterSvc;
    (function (MasterSvc) {
        MasterSvc.ThreePlSummaries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/threeplsummaries",
            OnBillboard: true
        };
        MasterSvc.ThreePls = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/threepls",
            OnBillboard: true
        };
        MasterSvc.ThreePlsBP = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/threeplsforbkgndprocess",
            OnBillboard: true
        };
        MasterSvc.ThreePlActivator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/threeplactivate",
            OnBillboard: true
        };
        MasterSvc.ApiCredentials = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/apicredentials",
            OnBillboard: true
        };
        MasterSvc.ApiRoles = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/apiroles",
            OnBillboard: true
        };
        MasterSvc.Logins = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/logins",
            OnBillboard: true
        };
        MasterSvc.Countries = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/countries",
            OnBillboard: true
        };
        MasterSvc.Persons = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/persons",
            OnBillboard: true
        };
        MasterSvc.HandlerParameters = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/handlerparameters",
            OnBillboard: true
        };
        MasterSvc.HandlerParameter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/handlerparameter",
            OnBillboard: true
        };
        MasterSvc.JobTypeQueues = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/jobtypequeues",
            OnBillboard: true
        };
        MasterSvc.ThreePlStatistics = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/threeplstatistics",
            OnBillboard: true
        };
        MasterSvc.SmallParcelStatistics = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/SmallParcelStatistics",
            OnBillboard: true
        };
        MasterSvc.AttachedDoc = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/attacheddoc",
            OnBillboard: true
        };
        MasterSvc.HttpTestGet = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/httptestget",
            OnBillboard: true
        };
        MasterSvc.HttpTestPut = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/httptestput",
            OnBillboard: true
        };
        MasterSvc.HttpTestPost = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/httptestpost",
            OnBillboard: true
        };
        MasterSvc.HttpTestDelete = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/httptestdelete",
            OnBillboard: true
        };
        MasterSvc.WebHooksConfig = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/webhooksconfig",
            OnBillboard: true
        };
        MasterSvc.ThreePl = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/threepl",
            OnBillboard: false
        };
        MasterSvc.ThreePlConnection = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/threeplconnection",
            OnBillboard: false
        };
        MasterSvc.ApiCredential = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/apicredential",
            OnBillboard: false
        };
        MasterSvc.ApiRole = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/apirole",
            OnBillboard: false
        };
        MasterSvc.Login = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/login",
            OnBillboard: false
        };
        MasterSvc.Person = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/person",
            OnBillboard: false
        };
        MasterSvc.JobTypeQueue = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/master",
            Rel: "http://api.3plCentral.com/rels/master/jobtypequeue",
            OnBillboard: false
        };
    })(MasterSvc = Rels.MasterSvc || (Rels.MasterSvc = {}));
    ;
    let JobSvc;
    (function (JobSvc) {
        JobSvc.Jobs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/jobs",
            OnBillboard: true
        };
        JobSvc.JobsStats = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/jobsstats",
            OnBillboard: true
        };
        JobSvc.JobMethods = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/jobmethods",
            OnBillboard: true
        };
        JobSvc.RecurringJobs = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/recurringjobs",
            OnBillboard: true
        };
        JobSvc.States = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/states",
            OnBillboard: true
        };
        JobSvc.Servers = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/servers",
            OnBillboard: true
        };
        JobSvc.Job = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/job",
            OnBillboard: false
        };
        JobSvc.Requeue = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/requeue",
            OnBillboard: false
        };
        JobSvc.JobHistory = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/jobhistory",
            OnBillboard: false
        };
        JobSvc.JobMethod = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/jobmethod",
            OnBillboard: false
        };
        JobSvc.JobFile = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/jobfile",
            OnBillboard: false
        };
        JobSvc.RecurringJob = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/recurringjob",
            OnBillboard: false
        };
        JobSvc.State = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/jobs",
            Rel: "http://api.3plCentral.com/rels/jobs/state",
            OnBillboard: false
        };
    })(JobSvc = Rels.JobSvc || (Rels.JobSvc = {}));
    ;
    let ToolSvc;
    (function (ToolSvc) {
        ToolSvc.WMSEventAbator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/wmseventabator",
            OnBillboard: true
        };
        ToolSvc.WarehouseTransactionEventRaiser = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/wteventraiser",
            OnBillboard: true
        };
        ToolSvc.WarehouseTransactionEventDeleter = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/wteventdeleter",
            OnBillboard: true
        };
        ToolSvc.BandwidthLogAbator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/bandwidthlogabator",
            OnBillboard: true
        };
        ToolSvc.CustomerErrorLogAbator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/customererrorlogabator",
            OnBillboard: true
        };
        ToolSvc.EventNotifyHistoryAbator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/eventnotifyhistoryabator",
            OnBillboard: true
        };
        ToolSvc.SmallParcelResponseAbator = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/smallparcelresponseabator",
            OnBillboard: true
        };
        ToolSvc.WMSEvent = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/wmsevent",
            OnBillboard: true
        };
        ToolSvc.WMSEventList = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "http://api.3plCentral.com/rels/wmstools/wmsevents",
            OnBillboard: true
        };
        ToolSvc.Nothin = {
            ServiceRel: "http://api.3plcentral.com/rels/billboard/servicebillboard/wmstools",
            Rel: "nothin",
            OnBillboard: false
        };
    })(ToolSvc = Rels.ToolSvc || (Rels.ToolSvc = {}));
})(Rels = exports.Rels || (exports.Rels = {}));
;
